'use client';

import { memo } from 'react';

import { SimpleTable, type SimpleTableColumn } from '@web/ui';
import { getDateTimeFormat } from '@web/utils';

import type { JoinRequestItem } from '@/features/workspaces/types';

type Props = {
  items: JoinRequestItem[];
  isLoading?: boolean;
};

export const SentJoinRequestsTable = memo(function SentJoinRequestsTable({
  items,
  isLoading = false,
}: Props) {
  const columns: Array<SimpleTableColumn<JoinRequestItem>> = [
    { header: 'Workspace', render: (jr) => jr.workspace.name },
    { header: 'Primary Domain', render: (jr) => jr.workspace.primary_domain },
    {
      header: 'Status',
      render: (jr) => (
        <span style={{ textTransform: 'capitalize' }}>{jr.status}</span>
      ),
    },
    {
      header: 'Created At',
      render: (jr) => getDateTimeFormat(jr.created_at),
      align: 'right',
    },
  ];

  if (!items?.length && !isLoading) return null;

  return (
    <SimpleTable
      title="Sent Join Requests"
      columns={columns}
      data={items}
      loading={isLoading}
      getRowKey={(r) => r.id}
    />
  );
});

SentJoinRequestsTable.displayName = 'SentJoinRequestsTable';
